export const moduleName = {
    'reflection': 'Reflection',
    'development': 'Development',
    'rolfing': 'Rolfing',
    'actionplan': 'Action plan',
    'pulse': 'Pulse',
  }